module.exports = __webpack_public_path__ + "img/pdf.64a7ca4f.png";